(function () {
    const FilterHeader = document.querySelector('.collection-filter-header');
    const ProductsGrid = document.querySelector('.collection-products-grid');
    const SelectorsContainer = document.querySelector('.collection-filter-selectors-container');
    const Selectors = document.querySelector('.collection-filter-selectors');
    const ProductCount = document.querySelector('.collection-product-count');
    const ClearBtn = document.querySelector('.collection-filter-clear:not(.mobile-only)');
    const ClearBtnMob = document.querySelector('.collection-filter-clear.mobile-only')

    function adjustGridPosition(heightPX) {
        if (window.innerWidth >= 768) {
            ProductsGrid.style.marginTop = heightPX;
        }
    }

    function initEvents() {
        document.querySelector('.collection-filter-trigger').addEventListener('click', function () {
            if (FilterHeader.classList.contains('filter-open')) {
                FilterHeader.classList.remove('filter-open');
            } else {
                FilterHeader.classList.add('filter-open');
            }

            if (SelectorsContainer.classList.contains('filter-open')) {
                SelectorsContainer.classList.remove('filter-open');
            } else {
                SelectorsContainer.classList.add('filter-open');
            }

            if (Selectors.classList.contains('filter-open')) {
                Selectors.classList.remove('filter-open');
            } else {
                Selectors.classList.add('filter-open');
            }

            if (ProductsGrid.classList.contains('filter-open')) {
                ProductsGrid.classList.remove('filter-open');
                adjustGridPosition(`0px`);
            } else {
                ProductsGrid.classList.add('filter-open');
                adjustGridPosition(`-${Selectors.offsetHeight}px`);
            }
        })

        document.querySelector('.collection-filter-close-btn').addEventListener('click', function () {
            FilterHeader.classList.remove('filter-open');
            SelectorsContainer.classList.remove('filter-open');
            Selectors.classList.remove('filter-open');
            ProductsGrid.classList.remove('filter-open');
        })

        document.querySelector('.collection-filter-clear:not(.mobile-only)').addEventListener('click', function () {
            const Options = document.querySelectorAll('input.filter-option-input:checked');
            for (let option of Options) {
                option.checked = false;
            }
            renderGrid();
        })
        document.querySelector('.collection-filter-clear.mobile-only').addEventListener('click', function () {
            const Options = document.querySelectorAll('input.filter-option-input:checked');
            for (let option of Options) {
                option.checked = false;
            }
            renderGrid();
        })

        $(".filter-option-input").on('change', function (e) {
            renderGrid();
        });

        $('input.checkbox-cerulean:not(.filter-option-input)').on('change', function (e) {
            let item = $(e.target).attr('data-option');
            $(`input.checkbox-cerulean.filter-option-input[data-filter-option="${item}"]`).prop('checked', true);
            $(`input.checkbox-cerulean.filter-option-input[data-filter-option="${item}"]`).trigger('change');
            let items = countItemsInGrid();
            $('span[data-filter-count]').html(`${items.length}`);
        });
    }

    function countItemsInGrid() {
        const Options = document.querySelectorAll('input.checkbox-cerulean:not(.filter-option-input):checked');
        const Products = ProductsGrid.querySelectorAll('.collection-product-container');

        let activeProduct = [];

        for (let product of Products) {
            const tags = product.getAttribute('data-product-tags');

            let tagExists = false;
            let tagOptions = [];
            for (let option of Options) {
                const tag = option.getAttribute('data-option');
                tagOptions.push(tag);
            }

            let countExist = tagOptions.filter(t => {
                return tags.includes(t);
            }).length;
            
            if (countExist === tagOptions.length) {
                tagExists = true;
            }

            if (tagExists) {
                activeProduct.push(product);
            }
        }

        return activeProduct;
    }

    function renderGrid() {
        const Options = document.querySelectorAll('input.filter-option-input:checked');
        const Products = ProductsGrid.querySelectorAll('.collection-product-container');

        if (Options.length === 0) {
            ProductCount.innerHTML = Products.length;
            ClearBtn.classList.add('hidden');
            ClearBtnMob.classList.add('hidden')
            adjustGridPosition(`-${Selectors.offsetHeight}px`)
            for (let product of Products) {
                product.classList.remove('hidden');
            }
            return;
        }

        ClearBtn.classList.remove('hidden');
        ClearBtnMob.classList.remove('hidden')
        adjustGridPosition(`-${Selectors.offsetHeight}px`)
        let activeProductCount = 0;

        for (let product of Products) {
            const tags = product.getAttribute('data-product-tags');

            let tagExists = false;
            for (let option of Options) {
                const tag = option.getAttribute('data-filter-option');
                if (tags.indexOf(tag) > -1) {
                    tagExists = true;
                    break;
                }
            }

            if (tagExists) {
                activeProductCount++;
                product.classList.remove('hidden');
            } else {
                product.classList.add('hidden');
            }
        }

        ProductCount.innerHTML = activeProductCount;
    }

    initEvents();
})()